export enum SignUpSteps {
	preRegistration = 'preRegistration',
	signUpApprove = "signUpApprove",
	checkCode = 'checkCode',
	registration = 'registration'
}
